import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import PrivacyData from "../../assets/privacy/cookie-privacy.json";
import ReactStars from 'react-stars';
// import GoogleMapsLoader from '../GoogleMapsLoader';
import axios from 'axios';


function ContactForm(props) {

  const [showPopup, setShowPopup] = useState(false);
  const [modalFade, setModalFade] = useState('fadeIn');
  const [status, setStatus] = useState(false);
  const dialogRef = useRef();
  const dialogContentRef = useRef();
  const consentRef = useRef();
  const consentContentRef = useRef();
  const newsletterRef = useRef();
  const newsletterContentRef = useRef();
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  const [idOrigin, setIdOrigin] = useState('');
  const [newsletterCheck, setNewsletterCheck] = useState(false);
  const [showConsensoModal, setShowConsensoModal] = useState(false);
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const consensoDatiText = PrivacyData.find((item) => item.id === props.ConsensoDatiID);
  const newsletterText = PrivacyData.find((item) => item.id === props.NewsletterID);
  const [rating, setRating] = useState(0);
  const [address, setAddress] = useState('');
  const brevo = process.env.REACT_APP_API_BREVO
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [apiProvinces, setApiProvinces] = useState([]);
  const [altroVisible, setAltroVisible] = useState('');

  const submitDialogTitleId = status ? "submit-dialog-title-success" : "submit-dialog-title-error";
  const consentDialogTitleId = "consent-dialog-title";
  const newsletterDialogTitleId = "newsletter-dialog-title";


  function handleRatingChange(newRating) {
    setRating(newRating);
  }

  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  const newsletterToggle = () => {
    setNewsletterCheck(!newsletterCheck);
  };

  const handelGetToken = async () => {
    try {
      const response = await fetch("https://crm.careholding.it/ws/auth/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          AppId: "5C3FE37C-90B3-484E-A049-C6A42F6DCD2E",
          AppSecret: "787BD90B-C45F-4F75-8EBC-4565575921DC",
        },
      });

      const data = await response.json();
      const token = data.Token;
      setToken(token);
      return token;
    } catch (error) {
      console.log("Token Error:", error);
      setModalFade('fadeIn');
      setShowPopup(true);
      setStatus(false);
      reset();
    }
  };

  useEffect(() => {
    const cookies = document.cookie.split('; ');
    console.log("cookies ", cookies)
    for (const cookie of cookies) {
      const [name, value] = cookie.split('=');
      if (name === 'IdOrigin') {
        console.log(value)
        setIdOrigin(value);
        break;
      }
    }
  }, []);

  useEffect(() => {
    if (token === '') {
      handelGetToken();
    }
  }, [token]);

  const onSubmit = async (data) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const newsletterMail = data.email;
    const additionalData = {
      NomeModulo: props.LandingName,
      Provenienza: idOrigin,
      Dati: [
        { Key: "NomeCognome", Value: data.nome_cognome || '' },
        { Key: "ZonaProvenienza", Value: address || '' },
        { Key: "Telefono", Value: data.telefono || '' },
        { Key: "Email", Value: data.email || '' },
        { Key: "InteressatoA", Value: data.interesse || '' },
        { Key: "Valutazione", Value: rating || 0 },
        { Key: "Recensione", Value: data.recensione || '' },
        { Key: "Messaggio", Value: data.free_text || '' },
        { Key: "CampoLibero", Value: data.textbox || '' },
        { Key: "Provincia", Value: data.provincia || '' },
        { Key: "ComeCiHaConosciuto", Value: data.interesse2 === 'Altro...' ? data.altroDropdownItem2 : data.interesse2 || '' },
      ],
    };

    console.log(additionalData)

    const responseToken = await handelGetToken();

    if (responseToken !== "") {
      try {
        // console.log(additionalData);
        const res = await fetch(
          "https://crm.careholding.it/ws/Call/?Cat=Leads&met=SaveLead&np=3",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AppId: "5C3FE37C-90B3-484E-A049-C6A42F6DCD2E",
              Token: responseToken,
            },
            body: JSON.stringify(additionalData),
          }
        );

        if (res.ok) {

          if (props.Newsletter && newsletterCheck) {

            const addContactToList = async (email) => {
              const url = `https://api.brevo.com/v3/contacts`;
              const data = {
                email,
                listIds: [props.NewsletterID],
              };
              const headers = {
                "api-key": brevo,
                "Content-Type": "application/json",
              };

              try {
                const response = await axios.post(url, data, { headers });
                console.log(response.data);
                console.log(props.NewsletterID);
                alert('')
              } catch (error) {
                if (error.response && error.response.status === 400) {
                  const brevoUrl = `https://api.brevo.com/v3/contacts/lists/${props.NewsletterID}/contacts/add`;
                  const brevoData = {
                    emails: [`${email}`],
                  };
                  const brevoHeaders = {
                    "api-key": brevo,
                    "Content-Type": "application/json",
                  };
                  try {
                    const response = await axios.post(brevoUrl, brevoData, {
                      headers: brevoHeaders,
                    });
                    console.log(response.data);
                  } catch (brevoError) {
                    console.error(brevoError);
                  }
                } else {
                  console.error(error);
                }
              }
            };

            addContactToList(newsletterMail);
          }

          setModalFade('fadeIn');
          setShowPopup(true);
          setStatus(true);
          reset();
        } else {
          setModalFade('fadeIn');
          setShowPopup(true);
          setStatus(false);
          reset();
        }
      } catch (error) {
        console.log("Errore invio modulo", error);
        setModalFade('fadeIn');
        setShowPopup(true);
        setStatus(false);
        reset();
      }
    } else {
      console.log("Token Error:", token);
      setModalFade('fadeIn');
      setShowPopup(true);
      setStatus(false);
      reset();
    }

  }

  const handleClosePopup = () => {
    setModalFade('fadeOut');
    setTimeout(() => {
      setShowPopup(false);
      dialogRef.current.close();
      setModalFade('fadeIn');
    }, 1500);
  };

  const handleSendTo = () => {
    setModalFade('fadeOut');
    setTimeout(() => {
      navigate(props.successLink);
      setShowPopup(false);
      dialogRef.current.close();
      setModalFade('fadeIn');
    }, 1500);
  }
  const openConsensoModal = () => {
    setShowConsensoModal(true);
  }

  const openNewsletterModal = () => {
    setShowNewsletterModal(true);
  }

  const handleCloseConsent = () => {
    setModalFade('fadeOut');
    setTimeout(() => {
      setShowConsensoModal(false);
      setModalFade('fadeIn');
    }, 1500);
  };

  const handleCloseNewsletter = () => {
    setModalFade('fadeOut');
    setTimeout(() => {
      setShowNewsletterModal(false);
      setModalFade('fadeIn');
    }, 1500);
  };

  useEffect(() => {
    const handleWheel = (event) => {
      if (consentContentRef.current && consentContentRef.current.contains(event.target)) {
        event.stopPropagation();
      }
      if (newsletterContentRef.current && newsletterContentRef.current.contains(event.target)) {
        event.stopPropagation();
      }
    };

    document.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      document.removeEventListener('wheel', handleWheel);
    };
  }, [showPopup]);

  const handleAddress = (selectedAddress) => {
    setAddress(selectedAddress);
  };

  const handleGetProvince = async () => {
    try {
      const response = await fetch(
        "https://crm.careholding.it/ws/Call/?Cat=Geografia&met=GetProvince&np=1", {
        method: "POST",
        body: JSON.stringify({
          IdNazione: 63
        }),
        headers: {
          "Content-Type": "application/json",
          AppId: "5C3FE37C-90B3-484E-A049-C6A42F6DCD2E",
          Token: token,
        },
      });
      const data = await response.json();
      // Assuming API returns a list of province names
      setApiProvinces(data || []); // Replace 'provinces' with the correct key in API response
    } catch (error) {
      console.error("Error fetching provinces:", error);
    }
  };

  useEffect(() => {
    if (token !== '') {
      handleGetProvince();
    }
  }, [token]);


  return (
    <form className='w-full md:p-10 text-start' onSubmit={handleSubmit(onSubmit)}>
      {props.Name && (
        <div className="mb-4 text-start">
          <label htmlFor="nome_cognome" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.NameText}</label>
          <input
            {...register("nome_cognome", {
              required: props.NameRequired ? 'Il nome e cognome è obbligatiorio' : false,
            })}
            type="text"
            id="nome_cognome"
            name="nome_cognome"
            className={`w-full ps-2 py-2 mt-1 border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          />
          {errors.nome_cognome && <div className='text-red-500'>* {errors.nome_cognome.message}</div>}
        </div>
      )}
      {props.Tel && (
        <div className="mb-4 text-start">
          <label htmlFor="telefono" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.TelText}</label>
          <input
            {...register("telefono", {
              required: props.TelRequired ? 'Il telefono è obbligatorio' : false,
            })}
            type="tel"
            id="telefono"
            name="telefono"
            className={`w-full ps-2 py-2 mt-1 border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          />
          {errors.telefono && <div className='text-red-500'>* {errors.telefono.message}</div>}
        </div>
      )}
      {props.Email && (
        <div className="mb-4 text-start">
          <label htmlFor="email" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.EmailText}</label>
          <input
            {...register("email", {
              required: props.EmailRequired ? 'L\'email è obbligatoria' : false,
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: 'Per favore inserisca una email valida',
              },
            })}
            type="email"
            id="email"
            name="email"
            className={`w-full ps-2 py-2 mt-1 border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          />
          {errors.email && <div className='text-red-500'>* {errors.email.message}</div>}
        </div>
      )}
      {props.provincia && (
        <div className="mb-4 text-start">
          <label htmlFor="provincia" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.provinciaText}</label>
          <select
            {...register("provincia", {
              required: 'Questo campo è obbligatorio',
            })}
            id="provincia"
            name="provincia"
            defaultValue=""
            className={`w-full mt-1 h-10 rounded border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          >
            <option value="" disabled >Seleziona la tua provincia</option>
            {apiProvinces.map((province) => (
              <option key={province.IDProvincia} value={province.Provincia}>
                {province.Provincia}
              </option>
            ))}
          </select>
          {errors.provincia && <div className='text-red-500'>* {errors.provincia.message}</div>}
        </div>
      )}
      {props.Dropdown && (
        <div className="mb-4 text-start">
          <label htmlFor="interesse" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.DropdownText}</label>
          <select
            {...register("interesse", {
              required: props.DropdownRequired ? 'Questo campo è obbligatorio' : false,
            })}
            id="interesse"
            name="interesse"
            className={`w-full mt-1 h-10 rounded border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          >
            {props.DropdownItem.map((item, index) => (
              <option key={index} value={item}>{item}</option>
            ))}
          </select>
          {errors.interesse && <div className='text-red-500'>* {errors.interesse.message}</div>}
        </div>
      )}
      {props.Dropdown2 && (
        <div className="mb-4 text-start">
          <label htmlFor="interesse" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.DropdownText2}</label>
          <select
            {...register("interesse2", {
              required: props.DropdownRequired2 ? 'Questo campo è obbligatorio' : false,
            })}
            id="interesse2"
            name="interesse2"
            onClick={(e) => { setAltroVisible(e.target.value) }}
            className={`w-full mt-1 h-10 rounded border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          >
            <option disabled value="" selected>Seleziona un'opzione</option>
            {props.DropdownItem2.map((item, index) => (
              <option key={index} value={item}>{item}</option>
            ))}
          </select>
          {errors.interesse2 && <div className='text-red-500'>* {errors.interesse2.message}</div>}
          {altroVisible === 'Altro...' && (
            <input
              {...register("altroDropdownItem2", {
                required: props.NameRequired ? 'Il nome e cognome è obbligatiorio' : false,
              })}
              type="text"
              id="altroDropdownItem2"
              name="altroDropdownItem2"
              placeholder="Inserisci dove ci hai conosciuto"
              className={`w-full ps-2 py-2 mt-1 border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
            />
          )}
        </div>

      )}
      {props.textBox && (
        <div className="mb-4 text-start">
          <label htmlFor="textbox" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.textBoxText}</label>
          <input
            {...register("textbox", {
              required: props.MessageTextRequired ? 'Questo campo è obbligatorio' : false,
            })}
            type="text"
            id="textbox"
            name="textbox"
            className={`w-full ps-2 py-2 mt-1 border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          />
          {errors.textbox && <div className='text-red-500'>* {errors.textbox.message}</div>}
        </div>
      )}
      {props.vote && (
        <div className="mb-4 text-start">
          <label className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.voteText}</label>
          <ReactStars
            count={5}
            value={rating}
            size={40}
            half={false}
            color2={"#DBBE6F"}
            color1={"#B3B3B3"}
            onChange={handleRatingChange}
            className="mb-1"
          />
          <textarea
            {...register("recensione", {
              required: props.MessageTextRequired ? 'Questo campo è obbligatorio' : false,
            })}
            type="text"
            id="recensione"
            name="recensione"
            rows="3"
            className={`w-full ps-2 py-2 mt-1 border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          />
          {errors.recensione && <div className='text-red-500'>* {errors.recensione.message}</div>}
        </div>
      )}
      {props.Message && (
        <div className="mb-3 text-start">
          <label htmlFor="free_text" className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>{props.MessageText}</label>
          <textarea
            {...register("free_text", {
              required: props.MessageTextRequired ? 'Questo campo è obbligatorio' : false
            })}
            id="free_text"
            name="free_text"
            rows="4"
            className={`w-full p-2 pb-10 mt-1 border ${props.Theme === 'light' ? 'bg-white text-black border-neutral-800' : 'bg-neutral-800 text-slate-50 border-neutral-800'} focus:outline-none`}
          ></textarea>
          {errors.free_text && <div className='text-red-500'>* {errors.free_text.message}</div>}
        </div>
      )}
      {props.ConsensoDati && (
        <>
          <div className="flex flex-row items-center justify-start text-start my-2">
            <input 
              {...register("consenso_dati", {
                required: props.ConsensoDatiRequired ? 'Questo campo è obbligatorio' : false
              })}
              type="checkbox"
              id="consensoDati"
              className="me-5 bg-white !border !border-black shrink-0"
            />
            <div className="block">
              Acconsento al trattamento dei miei dati personali come previsto nell'{' '}
              <button onClick={openConsensoModal} className={`inline hover:underline ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>
                {props.ConsensoDatiText}
              </button>
            </div>
          </div>
          {errors.consenso_dati && <div className='text-red-500'>* {errors.consenso_dati.message}</div>}
        </>
      )}
      {props.Newsletter && (
        <>
          <div className="flex-row flex items-center justify-start text-start my-2">
            <input
              {...register("news_letter", {
                required: props.NewsletterRequired ? 'Questo campo è obbligatorio' : false
              })}
              type="checkbox"
              id="news_letter"
              className="me-5"
              onClick={newsletterToggle}
            />
            <button type="button" onClick={openNewsletterModal} className={`block ${props.Theme === 'light' ? 'text-black' : 'text-slate-50'}`}>
              {props.NewsletterText}
            </button>
          </div>
          {errors.news_letter && <div className='text-red-500'>* {errors.news_letter.message}</div>}
        </>
      )}
      <button
        disabled={isSubmitting}
        type="submit"
        className={`py-2 mt-10 uppercase ${props.Theme === 'light' ? 'progress-button-dark border border-black text-black w-full md:w-6/12' : 'progress-button-light border border-slate-50 text-slate-50 w-full md:w-6/12'} transition duration-300 ease-in-out disabled:opacity-75`}
      >
        {isSubmitting ? 'Caricamento...' : props.SendText}
      </button>

      {showPopup && (
        <dialog
          ref={dialogRef}
          aria-modal="true"
          aria-labelledby={submitDialogTitleId}
          className={`fixed top-0 left-0 w-full h-full flex items-center justify-center glassmorphism ${modalFade}`} id={status ? "FormCompilato" : "ErroreForm"}>
          <div ref={dialogContentRef} className={`bg-white p-8 shadow-md text-center`}>
            <h2 className={`${status ? 'text-green-600' : 'text-rose-700'} text-center mb-10 text-lg`}>
              {status ? props.successText : props.errorText}
            </h2>
            {status ? (
              <button type="button" onClick={handleSendTo} className={`px-10 py-2 w-full progress-button-dark border border-black text-black transition duration-300 ease-in-out`}>
                Prosegui
              </button>
            ) : (
              <button type="button" onClick={handleClosePopup} className={`px-10 py-2 w-full progress-button-dark border border-black text-black transition duration-300 ease-in-out`}>
                Riprova
              </button>
            )}
          </div>
        </dialog>
      )}

      {showConsensoModal && (
        <dialog ref={consentRef} className={`fixed top-0 left-0 w-full h-full flex items-center justify-center glassmorphism ${modalFade}`}
        onWheel={(e) => e.stopPropagation()}
        onTouchMove={(e) => e.stopPropagation()}>
          <div ref={consentContentRef} className="modal-container bg-white p-8 shadow-md space-y-10">
            <h2 className="text-2xl font-bold text-center">{consensoDatiText.title}</h2>
            <p>{consensoDatiText.intro}</p>
            <div className="space-y-5">
              {consensoDatiText.sections.map((section, index) => (
                <div key={index} className="space-y-2">
                  <h3 className="text-lg font-semibold">{section.heading}</h3>
                  {section.paragraphs.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              ))}
            </div>
            <div className="space-y-5">
              <h2 className="text-xl font-bold text-center">{consensoDatiText.dataSubjectRights.heading}</h2>
              <p>{consensoDatiText.dataSubjectRights.intro}</p>
              <ul className="space-y-2">
                {consensoDatiText.dataSubjectRights.items.map((item, index) => (
                  <li key={index}>
                    <h3 className="text-lg font-semibold">{item.title}</h3>
                    <p>{item.description}</p>
                  </li>
                ))}
              </ul>
            </div>
            <div className="space-y-5">
              <h2 className="text-xl font-bold text-center">{consensoDatiText.controller.heading}</h2>
              <p>
                {consensoDatiText.controller.companies.join(", ")}, con sede operativa in{' '}
                {consensoDatiText.controller.operativeOffice}.
              </p>
              <p>È identificato un Responsabile della Protezione dei Dati all'indirizzo{" "}
                <a href={`mailto:${consensoDatiText.controller.dpoEmail}`}>
                  {consensoDatiText.controller.dpoEmail}
                </a>.
              </p>
            </div>
            <div className='items-center flex flex-col'>
              <button onClick={handleCloseConsent} className="w-1/2 py-4 progress-button-dark border border-black text-black transition duration-300 ease-in-out">
                Chiudi
              </button>
            </div>
          </div>
        </dialog>
      )}

      {showNewsletterModal && (
        <dialog
          ref={newsletterRef}
          aria-modal="true"
          aria-labelledby={newsletterDialogTitleId}
          className={`fixed top-0 left-0 w-full h-full flex items-center justify-center glassmorphism ${modalFade}`}>
          <div ref={newsletterContentRef} className="modal-container bg-white p-8 shadow-md md:m-56">
            <p className="text-start" dangerouslySetInnerHTML={createMarkup(consensoDatiText.content)}>
            </p>
            <div className='items-center flex flex-col'>
              <button type="button" onClick={handleCloseNewsletter} className="w-1/2 py-4 progress-button-dark border border-black text-black transition duration-300 ease-in-out">
                Chiudi
              </button>
            </div>
          </div>
        </dialog>
      )}
    </form>
  );
}

export default ContactForm;
